// extracted by mini-css-extract-plugin
export default {"repairBtn":"Button_repairBtn__RJFxA","backBtn":"Button_backBtn__fIaXD","customBorder":"Button_customBorder__nNsc4"};